import { currencySymbol, formatDate, formatMoney } from "@/lib/format";
import { cn } from "@/lib/utils";
import type { PaymentRow } from "@/types/domain";

const STATUS_LABEL: Record<PaymentRow["payment_status"], string> = {
  PAID: "Pagado",
  FAILED: "Rechazado",
  PENDING: "Pendiente",
  REFUNDED: "Devuelto",
};

const STATUS_CLASS: Record<PaymentRow["payment_status"], string> = {
  PAID: "text-emerald-600 dark:text-emerald-400",
  FAILED: "text-red-600 dark:text-red-400",
  PENDING: "text-amber-600 dark:text-amber-400",
  REFUNDED: "text-slate-500 dark:text-slate-400",
};

export function PaymentHistoryTable({ payments }: { payments: PaymentRow[] }) {
  return (
    <div className="rounded-2xl border border-slate-100 bg-white p-6 shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <h2 className="text-base font-extrabold text-slate-800 dark:text-slate-100">
        Historial de pagos
      </h2>

      {payments.length === 0 ? (
        <p className="mt-3 text-sm text-slate-400 dark:text-slate-500">
          Todavía no hay cargos registrados.
        </p>
      ) : (
        <div className="mt-4 overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-slate-100 text-left text-xs text-slate-400 dark:border-slate-800 dark:text-slate-500">
                <th className="pb-2 font-medium">Fecha</th>
                <th className="pb-2 font-medium">Monto</th>
                <th className="pb-2 text-right font-medium">Estado</th>
              </tr>
            </thead>
            <tbody>
              {payments.map((payment) => (
                <tr
                  key={payment.payment_id}
                  className="border-b border-slate-50 last:border-0 dark:border-slate-800/60"
                >
                  <td className="py-2.5 text-slate-600 dark:text-slate-300">
                    {formatDate(payment.payment_createdat)}
                  </td>
                  <td className="py-2.5 font-semibold text-slate-800 dark:text-slate-100">
                    {/* Con céntimos: es un cobro real al usuario, S/ 49.90 no
                        es S/ 50. */}
                    {formatMoney(
                      payment.payment_amount,
                      currencySymbol(payment.payment_currency),
                      true,
                    )}
                  </td>
                  <td
                    className={cn(
                      "py-2.5 text-right font-semibold",
                      STATUS_CLASS[payment.payment_status],
                    )}
                  >
                    {STATUS_LABEL[payment.payment_status]}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
